import { SET_ACCOUNT_PERSON_ID } from 'actions';

export function setAccountPersonId(personId: string) {
  return { personId, type: SET_ACCOUNT_PERSON_ID };
}
